import { useEffect, useRef } from "react";

export default function HeroSection() {
  const heroRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const el = heroRef.current;
    if (!el) return;
    const onScroll = () => {
      const y = window.scrollY;
      el.style.backgroundPositionY = `${50 + y * 0.05}%`;
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <section
      ref={heroRef}
      className="relative min-h-[100dvh] flex items-center justify-center overflow-hidden"
      style={{
        backgroundImage:
          "url(https://readdy.ai/api/search-image?query=abstract%20dark%20luxury%20minimalist%20background%20with%20subtle%20gold%20and%20green%20gradient%20tones%2C%20elegant%20corporate%20finance%20atmosphere%2C%20soft%20lighting%20with%20geometric%20shapes%20fading%20into%20darkness%2C%20no%20text%2C%20high%20quality%20professional%20presentation%20backdrop&width=1920&height=1080&seq=hero-bg-001&orientation=landscape)",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <div className="absolute inset-0 bg-dark-950/80" />
      <div className="absolute inset-0 bg-gradient-to-b from-dark-950/60 via-transparent to-dark-950/90" />

      <div className="relative z-10 text-center px-4 max-w-4xl mx-auto pt-20">
        <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/10 backdrop-blur-sm border border-white/10 mb-6">
          <span className="w-2 h-2 rounded-full bg-primary-400 animate-pulse" />
          <span className="text-xs md:text-sm text-white/80 font-medium tracking-wide">
            One-on-One Personal Credit Repair
          </span>
        </div>

        <h1 className="font-serif text-4xl sm:text-5xl md:text-6xl lg:text-7xl text-white leading-tight mb-4">
          Authentic Credit
          <br />
          <span className="text-primary-400">Restoration</span>
        </h1>

        <p className="text-base md:text-lg text-white/70 max-w-2xl mx-auto mb-3 leading-relaxed">
          Everything done utilizing the Fair Credit Reporting Act of 1984.
        </p>

        <p className="text-sm md:text-base text-white/50 max-w-xl mx-auto mb-10 leading-relaxed">
          We fix personal and corporate credit in all 50 states.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="tel:754-777-6321"
            className="px-8 py-4 rounded-lg bg-primary-600 text-white font-semibold text-base hover:bg-primary-700 transition-all shadow-lg shadow-primary-900/30 cursor-pointer whitespace-nowrap flex items-center gap-2"
          >
            <i className="ri-phone-line" />
            Call for Daily Special Pricing
          </a>
          <a
            href="mailto:info@fastestcreditrestoration.com"
            className="px-8 py-4 rounded-lg bg-white/10 backdrop-blur-sm text-white font-semibold text-base border border-white/20 hover:bg-white/20 transition-all cursor-pointer whitespace-nowrap flex items-center gap-2"
          >
            <i className="ri-mail-line" />
            Email Us
          </a>
        </div>

        <div className="mt-16 grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6 max-w-3xl mx-auto">
          {[
            { value: "50", label: "States Served" },
            { value: "Both", label: "Personal & Corporate" },
            { value: "FCRA", label: "1984 Law" },
            { value: "48h", label: "Response Time" },
          ].map((stat) => (
            <div key={stat.label} className="text-center">
              <div className="text-2xl md:text-3xl font-bold text-primary-400 font-heading">
                {stat.value}
              </div>
              <div className="text-xs md:text-sm text-white/50 mt-1">
                {stat.label}
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 h-24 bg-gradient-to-t from-white to-transparent z-10" />
    </section>
  );
}